<script lang="ts">
  import { jobsData } from "../../../app/store/store-careers";
  import JobCard from "./JobCard.svelte";
</script>

<div class="section-content">
  <h1 class="section-title">Open Job Positions</h1>

  <div class="section-description">
    Datadocs is a large, complex application and we are always looking for
    talented engineers to join our team and/or contribute to the open-source
    projects we work with. Here are some of the various roles we are actively
    looking for:
  </div>

  <div class="pt-12 pb-24 space-y-6">
    {#each jobsData as data}
      <JobCard {data} />
    {/each}
  </div>
</div>

<style lang="postcss">
  .section-content {
    width: min(720px, calc(100% - 20px)) !important;
  }

  .section-content .section-title {
    @apply text-center mt-12 typo-heading-1;
    max-width: fit-content;
    background: linear-gradient(90.76deg, #5f89ff 0%, #3bc7ff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  }

  @media (max-width: 640px) {
    .section-content .section-title {
      @apply typo-heading-2;
      font-weight: 700;
    }
  }

  .section-description {
    @apply text-center mx-auto mt-4 typo-paragraph-1;
    width: min(620px, calc(100% - 32px)) !important;
  }
</style>
